var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeNotActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 7.1133V17.0189C17 18.113 16.1046 19 15 19H5C3.89543 19 3 18.113 3 17.0189V7.1133M13 19V14.0472C13 12.9531 12.1046 12.0661 11 12.0661H9C7.89543 12.0661 7 12.9531 7 14.0472V19M19 9.09442L11.4142 1.58026C10.6332 0.806582 9.36684 0.806581 8.58579 1.58025L1 9.09442",
    stroke: "#AAAAAA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeNotActive);
export default __webpack_public_path__ + "static/media/home-not-active.9f6e6e7f3a62d21916d3073efe0a0fb7.svg";
export { ForwardRef as ReactComponent };